import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { localNews, nearbyEvents, usefulServices } from '../../data/espace';
function SectionHeading({
  title,
  hint
}: {
  title: string;
  hint?: string;
}) {
  return <div data-id="element-1442" data-mp="1g1v46vjm5d72">
      <button type="button" className="group inline-flex items-center gap-2 rounded text-2xl font-extrabold tracking-tight text-ville-navy transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1443" data-mp="1g1lb2z39upx5">
        {title}
        <ChevronRightIcon className="h-6 w-6 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1444" data-mp="1yu5rvi5p54kl" />
      </button>
      {hint && <p className="mt-1 text-[15px] text-slate-500" data-id="element-1445" data-mp="ngtu9p0j5i6v">{hint}</p>}
    </div>;
}
export function LocalNews() {
  return <section aria-labelledby="nouvelles-titre" className="mt-12" data-id="element-1446" data-mp="jfrrwzbbgq0o">
      <h2 id="nouvelles-titre" className="sr-only" data-id="element-1447" data-mp="1qnz53iuuvrb">
        Mes nouvelles locales
      </h2>
      <SectionHeading title="Mes nouvelles locales" data-id="element-1448" data-mp="6neflrykntd9" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1449" data-mp="3ou2hza28m2f8">
        {localNews.map(item => <li key={item.id} className="flex" data-id="element-1450" data-mp="3svntaqz4i8nb">
            <Link to={item.to ?? '/mon-espace'} className="group flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1451" data-mp="3suckgcqtmapc">
              <img src={item.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1452" data-mp="357wb56qwj1e4" />
              <span className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1453" data-mp="3a5fq68vfbi74">
                <span className="text-sm text-slate-500" data-id="element-1454" data-mp="2w6g2b3fqj7c0">{item.date}</span>
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-ville-indigo" data-id="element-1455" data-mp="314836mycy3sc">
                  {item.category}
                </span>
                <span className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1456" data-mp="16pkmtmi3zhr5">{item.title}</span>
                <span className="mt-auto pt-3 text-right text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-1457" data-mp="11vgeozx3x3oh">
                  Lire plus
                </span>
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}
export function NearbyEvents() {
  return <section aria-labelledby="evenements-titre" className="mt-12" data-id="element-1458" data-mp="1kp3qa1zz64x4">
      <h2 id="evenements-titre" className="sr-only" data-id="element-1459" data-mp="1gm73dz3ejmnd">
        Mes événements à proximité
      </h2>
      <SectionHeading title="Mes événements à proximité" data-id="element-1460" data-mp="1bnmdotls0ld6" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1461" data-mp="1bn2vrcw4lwz5">
        {nearbyEvents.map(event => <li key={event.id} className="flex" data-id="element-1462" data-mp="557dtb8fvlx1">
            <article className="flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1463" data-mp="7xpjywsdgas">
              <img src={event.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1464" data-mp="2bwlsm7humdmq" />
              <div className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1465" data-mp="2gtu8u2jfs7lc">
                <p className="text-sm font-semibold text-ville-indigo" data-id="element-1466" data-mp="2kw8wr11ypxjh">{event.date}</p>
                {event.time && <p className="text-sm text-slate-500" data-id="element-1467" data-mp="2pmxomhhk0wj5">{event.time}</p>}
                <h3 className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1468" data-mp="2pp1zjjdvevsx">{event.title}</h3>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}
export function UsefulServices() {
  return <section aria-labelledby="services-utiles-titre" className="mt-12" data-id="element-1469" data-mp="34joqcxepakbx">
      <h2 id="services-utiles-titre" className="sr-only" data-id="element-1470" data-mp="38ltejgmdqor6">
        Mes services utiles
      </h2>
      <SectionHeading title="Mes services utiles" hint="Horaires et informations de base" data-id="element-1471" data-mp="38jgwz4kjagen" />

      <ul className="-mx-5 mt-5 flex snap-x gap-4 overflow-x-auto px-5 pb-2 lg:-mx-10 lg:px-10" data-id="element-1472" data-mp="1a8jn3u7j09x4">
        {usefulServices.map(service => <li key={service.id} className="w-[210px] shrink-0 snap-start" data-id="element-1473" data-mp="iwubq7lbfmbl">
            <article className="h-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1474" data-mp="ewael40qsipg">
              <img src={service.image} alt="" className="h-32 w-full object-cover" data-id="element-1475" data-mp="svjj36fl5odl" />
              <div className="p-4 text-center" data-id="element-1476" data-mp="nwp2mb53cbwn">
                <h3 className="text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1477" data-mp="ny06sc2g7loa">{service.name}</h3>
                <p className={`mt-2 text-sm font-bold ${service.open ? 'text-ville-indigo' : 'text-slate-500'}`} data-id="element-1478" data-mp="7w3y6x33pyc">
                  {service.open ? 'Ouvert' : 'Fermé'}
                </p>
                <p className="text-xs text-slate-500" data-id="element-1479" data-mp="9z0hr3b0x4rl">{service.hours}</p>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}